import Slider from '@mui/material/Slider';

import PropTypes from 'prop-types';

import _ from 'lodash';

export default function RangeSlider(props) {
    
    const { min, max, defaultValues, onChange, width } = props;

    const handleChange = (event, newValues) => {
        if (onChange) {
            onChange(newValues);
        }
    };

    const valuetext = (val) => {
        return `R${val}`;
    };

    return (
        <div className='slider-container'>
            <Slider
                value={_.map(defaultValues, Number)}
                onChange={handleChange}               
                aria-labelledby="price-range-slider"
                getAriaValueText={valuetext}
                min={min}
                max={max}
                className='slider'
            />
        </div>
    );
}

RangeSlider.propTypes = {
    min: PropTypes.number,
    max: PropTypes.number,
    defaultValues: PropTypes.array,
    width: PropTypes.number,

    onChange: PropTypes.func,
};

